import { DIALOG_LEAVE_ANIMATION_DURATION } from '@/config';
import { useCallback, useEffect, useState } from 'react';

interface UseModalOptions {
  animationDuration?: number;
}

export const useDialog = (options: UseModalOptions = {}) => {
  const { animationDuration = DIALOG_LEAVE_ANIMATION_DURATION } = options;
  const [isOpen, setIsOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setMounted(true);
    } else {
      const timer = setTimeout(() => {
        setMounted(false);
      }, animationDuration);

      return () => clearTimeout(timer);
    }
  }, [isOpen, animationDuration]);

  const openDialog = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    mounted,
    openDialog,
    closeDialog,
  } as const;
};
